export const generateSaveRallyPayload = ({ formState, }) => ({
    themes: formState.selectedThemes,
    internalTitle: formState.internalTitle,
    title: {
        de: formState.titleTranslations.de,
        en: formState.titleTranslations.en,
        cs: formState.titleTranslations.cs,
    },
    description: {
        de: formState.descriptionTranslations.de,
        en: formState.descriptionTranslations.en,
        cs: formState.descriptionTranslations.cs,
    },
    targetGroups: formState.selectedTargetGroups,
    isTeamRally: formState.isTeamRally,
    isLinear: formState.isLinearRally,
    visibility: formState.isPublicRally ? 'public' : 'private',
    maxDuration: +formState.minutes,
    badge: formState.badge,
    image: formState.image,
    isTimeLimit: formState.isRallyTimeLimit,
    latitude: formState.latitude,
    longitude: formState.longitude,
});
